import React from 'react';
import {
  FaFacebookSquare,
  FaLinkedinIn,
  FaInstagram,
  FaTwitter,
} from 'react-icons/fa';
import { IoIosCall } from 'react-icons/io';
import { CgMail } from 'react-icons/cg';
import { MdLocationOn } from 'react-icons/md';
import ContactLogo from '../../Assets/logo/TenderwiseFooterLogo.png';
import { useNavigate } from 'react-router-dom';
import Footer from './../Footer/Footer';
const Contact = () => {
  const navigate = useNavigate();
  const handleHomeClick = () => {
    navigate('/');
  };
  const handleServiceClick = item => {
     window.scrollTo(0, 0);
    navigate('/services');
  };
  const handleAboutClick = item => {
     window.scrollTo(0, 0);
    navigate('/about');
  };
  const handleContactUsClick = item => {
     window.scrollTo(0, 0);
    navigate('/contactUs');
  };
  return (
    <>
      <div className="bg-ContactUsBg text-white md:py-6 py-2 md:px-16 2xl:px-44 px-6">
        <div className="container mx-auto">
          <a href="#">
            <img src={ContactLogo} alt="Logo" className="h-10 md:h-14 mb-2" />
          </a>
        </div>
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 2xl:gap-80 md:gap-40 gap-8 ">
          {/* Section One: Logo, Text, and Social Icons */}
          <div className="flex flex-col items-start ">
            <p className="md:mb-6 mb-4 text-sm md:text-sm">
            Tender Wise is a comprehensive tender portal that connects organizations with tender opportunities. We aggregate tenders from various sources, including government e-GP platforms, international tenders, and private organizations that request tender publishing.
            </p>
            <div className="flex md:space-x-4 space-x-2">
              <a href="#" className="hover:text-gray-400 text-white">
                <FaFacebookSquare size={20} />
              </a>
              <a href="#" className="hover:text-gray-400 text-white">
                <FaTwitter size={20} />
              </a>
              <a href="#" className="hover:text-gray-400 text-white">
                <FaLinkedinIn size={20} />
              </a>
              <a href="#" className="hover:text-gray-400 text-white">
                <FaInstagram size={20} />
              </a>
            </div>
          </div>

          {/* Section Two: Our Services */}
          <div>
            <h3 className="md:text-lg text-sm font-semibold md:mb-4 mb-2 relative">
              Our Company
              <span className="block w-1/3 h-0.5 bg-gray-400 mt-1 mb-1"></span>
            </h3>

            <ul className="md:space-y-1 text-sm">
              <li>
                <button
                  onClick={handleAboutClick}
                  className="hover:text-headerBtn"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={handleContactUsClick}
                  className="hover:text-headerBtn"
                >
                  Contact Us
                </button>
              </li>
              <li>
                <button
                // onClick={handleServiceClick}
                // className="hover:text-headerBtn"
                >
                  Our Services
                </button>
              </li>
            </ul>
          </div>

          {/* Section Three: Contact Us */}
          <div>
            {/* <h3 className="text-xl font-semibold md:mb-4 mb-2">Contact Us</h3> */}
            <h3 className="md:text-lg text-sm font-semibold md:mb-4 mb-2 relative uppercase">
              Contact Us
              <span className="block w-1/3 h-0.5 bg-gray-400 mt-1 mb-1"></span>
            </h3>
            <ul className="md:space-y-3 text-sm">
              <li className="flex items-center space-x-2">
                <IoIosCall className=" text-white" />
                <span>+880 1897-621261</span>
              </li>
              <li className="flex items-center space-x-2">
                <CgMail className=" text-white" />
                <span>info@tenderwise.xyz</span>
              </li>
              <li className="flex items-center space-x-2">
                <MdLocationOn className=" text-white" />
                <span>Baridhara DOHS, Dhaka, 1206</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
